import useSWR from 'swr';

var useDynamicLabel = function useDynamicLabel(entityType, entityId, fieldName, locale, params) {
  var isParamsReady = !params.includes('NaN') && !params.includes('undefined');

  var _useSWR = useSWR(isParamsReady ? "/msvc/v1/translations/values/".concat(entityType, "/").concat(entityId, "/").concat(fieldName, "/").concat(locale, "/value?").concat(params) : null, {
    revalidateOnFocus: false
  }),
      data = _useSWR.data,
      error = _useSWR.error,
      isValidating = _useSWR.isValidating;

  return {
    error: error,
    data: data,
    isValidating: isValidating
  };
};

export default useDynamicLabel;